import { Fragment, useEffect } from 'react'
import { useForm } from 'react-final-form'
import { useSelector } from 'react-redux'
import { useStepper } from 'src/components/StepperWalliro/stepperContext'
import { providerNameSelector, shouldSwitchWalletChain } from 'src/logic/wallets/store/selectors'
import { objectByString } from 'src/utils/objects'
import { FIELD_LOAD_SAFE_ADDRESS, StarterFormValues } from '../../fields/starterFields'
import LoadSafeAddressStep, { loadSafeAddressStepValidations } from './LoadSafeAddressStep'
import LoadSafeOwnersStep from './LoadSafeOwnersStep'

const LoadWalliro = () => {
  const loadSafeForm = useForm()

  const formValues = loadSafeForm.getState().values as StarterFormValues

  const validateSafeAddress = loadSafeAddressStepValidations(formValues)

  return (
    <Fragment>
      <LoadSafeAddressStep />
      {Object.keys(validateSafeAddress).length === 0 && <LoadSafeOwnersStep />}
    </Fragment>
  )
}

export default LoadWalliro
